<template>
  <div class="ace-intro">
    <div class="ace-intro__logo">
      <img
        srcset="@/assets/images/logo.png, @/assets/images/logo@2x.png 2x"
        src="@/assets/images/logo.png"
        alt="Adesco Carbon Calculator"
      />
    </div>
    <div class="ace-content">
      <h2 class="ace-intro__title">Cutting the carbon footprint of animal feed.</h2>
      <div class="ace-intro__body">
        <p>
          ACE is a convenient way to accurately estimate carbon footprint. It provides the technical
          information required to accelerate carbon reduction, while protecting quality during
          storage and processing.
        </p>
      </div>
      <ButtonGroup class="ace-intro__buttons">
        <Button
          variant="dark"
          icon="arrow"
          text="Begin for Grains &amp; Beans"
          @click="$emit('setCalculator', 'grain')"
        />
        <Button
          variant="light"
          icon="arrow"
          text="Begin for feed"
          @click="$emit('setCalculator', 'feed')"
        />
      </ButtonGroup>
    </div>
  </div>
</template>

<script>
import ButtonGroup from './Layout/ButtonGroup.vue';
import Button from './Layout/Button.vue';

export default {
  data() {
    return {};
  },
  props: [],
  // props: {},
  methods: {},
  computed: {},
  components: {
    ButtonGroup,
    Button,
  },
};
</script>

<style scoped lang="scss">
@import '~@/assets/styles/mixins';

.ace-intro {
  margin: 60px auto 0;
  max-width: 680px;
  &__title {
    @include title;
  }
  &__body {
    p {
      margin: 0 auto;
      max-width: 620px;

      font-size: 21px;
      font-weight: 300;
    }
  }
  &__buttons {
    margin: 40px 0 0;
  }
}
</style>
